import { getTimelapseBackgroundColor, getTimelapseStatusColor, getTimelapseStatusText, TimelapseStatus as TimelapseStatusType } from "@/lib/types/timelapse"
import { Badge, BadgeProps } from "@mantine/core";

type Props = {
  status: TimelapseStatusType;
  noText?: boolean;
} & BadgeProps

export const TimelapseStatus = ({ status, noText = false, ...props }: Props) => {
  if (noText) return <div className={`rounded-full w-2 h-2 ${getTimelapseBackgroundColor(status)}`} />

  return (
    <Badge size="lg" variant="light" color={getTimelapseStatusColor(status)} {...props}>{getTimelapseStatusText(status)}</Badge>
  )
}
